import { render } from "./cz.vue?vue&type=template&id=e799cf52&scoped=true"
import script from "./cz.vue?vue&type=script&lang=js"
export * from "./cz.vue?vue&type=script&lang=js"

import "./cz.vue?vue&type=style&index=0&id=e799cf52&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e799cf52"]])

export default __exports__